<template>
  <v-dialog v-model="show" max-width="500" scrollable>
    <v-card class="grey lighten-3 black--text">
      <v-card-title>
        <ADialogTitle title="Missing Parts" @close="show = false"></ADialogTitle>
      </v-card-title>
      <v-card-text class="body-1 white">
        <div class="row pa-0 ma-0 align-center subtitle" v-if="inputs.length > 0">
          <div class="col-6 text-center">Part Name</div>
          <div class="col-4 text-center">Quantity</div>
        </div>
        <v-form ref="form">
          <template v-for="(v,i) in inputs">
            <div class="row pa-0 ma-0" :key="i">
              <div class="col-6">
                <v-text-field v-model="v[0]" dense outlined :rules="inputsMeta[0].rules" @keyup.enter="save"></v-text-field>
              </div>
              <div class="col-4">
                <v-text-field v-model="v[1]" dense outlined :rules="inputsMeta[1].rules" @keyup.enter="save"></v-text-field>
              </div>
              <div class="col-2">
                <v-btn text @click="remove(i)" v-if="!(inputs.length == 1 && i == 0)">
                  <v-icon small>close</v-icon>
                </v-btn>
              </div>
            </div>
          </template>
        </v-form>
        <div class="row justify-center align-center">
          <div class="col-12 text-center">
            <v-btn text color="primary" @click="add">
              <v-icon left>add</v-icon>ADD ITEM
            </v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-container class="text-right pa-0 ma-0">
          <!-- <v-btn text color="error" large @click="clear()" @keydown.esc="no">clear all</v-btn> -->
          <!-- <v-btn text color="error" large @click="clear" @keydown.esc="no">Remove All</v-btn> -->
          <v-btn text color="success" large @click="save" @keydown.enter="yes">Save</v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash"
import ADialogTitle from "./dialog/ADialogTitle";
import snackbar from "../mixins/snackbar";

export default {
  name: "AMultiInputModal",
  mixins: [snackbar],
  components: { ADialogTitle },
  data() {
    return {
      show: false,
      inputsMeta: [
        {
          type: "text",
          rules: [v => !!v || "Required"]
        },
        {
          type: "text",
          rules: [
            v => !!v || "Required",
            v => Number.isInteger(Number.parseInt(v)) || "Must be an integer"
          ]
        }
      ],
      inputs: []
    };
  },
  computed: {
    inputsTransformed: function() {
      let computed = [];
      this.inputs.forEach(e => {
        if (e[0] && e[1]) {
          computed.push([e[0], parseInt(e[1])]);
        }
      });
      return computed;
    }
  },
  watch: {
    inputs: function() {
      if (this.inputs.length == 0) this.add();
    }
  },
  methods: {
    setInputs(arr) {
      this.inputs.splice(0);
      arr.forEach((e, i) => {
        this.$set(this.inputs, i, e);
      });
    },
    open(data) {
      this.show = true;
      this.setInputs(_.cloneDeep(data));
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    add() {
      this.inputs.push(["", undefined]);
    },
    remove(index) {
      this.inputs.splice(index, 1);
    },
    clear() {
      const vm = this;
      this.inputs.splice(0);
      this.$refs.form.resetValidation();
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.emitOutput();
      this.show = false;
    },
    emitOutput() {
      this.$emit("update:input", this.inputsTransformed);
    }
  }
};
</script>